// Print anexado no chat: reduzido no navegador antes de subir; o da tela atual é capturado sozinho.

const LADO = 1600;
/** Teto do data URL em caracteres (~1,1 MB de imagem); o servidor confere o mesmo (views.MAX_PRINT). */
export const MAX_PRINT = 1_500_000;

/** Reduz para no máximo 1600 px e JPEG; erro com mensagem pronta para a tela. */
export async function reduzirPrint(arquivo) {
  if (!arquivo.type.startsWith("image/")) throw new Error("Escolha uma imagem (um print da tela).");
  const bmp = await createImageBitmap(arquivo).catch(() => {
    throw new Error("Não consegui abrir essa imagem.");
  });
  const k = Math.min(1, LADO / Math.max(bmp.width, bmp.height));
  const c = document.createElement("canvas");
  c.width = Math.round(bmp.width * k);
  c.height = Math.round(bmp.height * k);
  const g = c.getContext("2d");
  g.fillStyle = "#fff"; // PNG transparente não vira fundo preto no JPEG
  g.fillRect(0, 0, c.width, c.height);
  g.drawImage(bmp, 0, 0, c.width, c.height);
  bmp.close();
  const url = c.toDataURL("image/jpeg", 0.85);
  if (url.length > MAX_PRINT) throw new Error("A imagem ficou grande demais. Tente um print menor.");
  return url;
}

/** Imagem colada (Ctrl+V) no campo, se houver. */
export const imagemColada = (dados) => [...(dados?.files ?? [])].find((f) => f.type.startsWith("image/"));

// O chat e o guia ficam fora da imagem: a IA precisa ver a tela, não o próprio chat.
const FORA = "[data-suporte-ia], [data-guia-interativo]";
const PIXEL = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

/** Print da parte visível da tela atual (DOM → imagem no navegador, sem permissão), já reduzido. */
export async function capturarTela() {
  try {
    const { toCanvas } = await import("html-to-image");
    const canvas = await toCanvas(document.body, {
      width: window.innerWidth,
      height: window.innerHeight,
      pixelRatio: 1,
      skipFonts: true,
      backgroundColor: "#fff",
      imagePlaceholder: PIXEL, // imagem que não carrega não derruba a captura
      style: { transform: `translate(${-window.scrollX}px, ${-window.scrollY}px)`, transformOrigin: "top left" },
      filter: (no) => !(no instanceof Element && no.closest(FORA)),
    });
    const blob = await new Promise((ok) => canvas.toBlob(ok, "image/png"));
    if (!blob) throw new Error("vazio");
    return await reduzirPrint(blob);
  } catch (e) {
    throw new Error(e?.message?.startsWith("A imagem") ? e.message : "Não consegui capturar a tela.");
  }
}
